export const desktopContentContainerPaperStyle = {
    borderRadius: '20px'
}

export const desktopContentContainerPaperDivStyle = {
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '50px',
    marginBottom: '50px'
}


export const desktopImageContainerStyle= {
    textAlign: 'center',
    display: 'inline-block',
    width: '333px%',
    marginTop: 25,
    marginBottom: 25,
    marginRight: 25
}

export const desktopWelcomeTextContainerStyle= {
    display: 'inline-block',
    width: '60%',
    verticalAlign: 'top',
    marginLeft: '50px'

}

export const tabletProjectAndAboutTabletTextStyle = {
    marginTop: '-30px',
    marginLeft: '5%',
    marginBottom: '40px',
    width: '80%'
}

export const desktopDropdownContainerStyle = {
    textAlign: 'center',
    margin: 10
}

export const desktopFormControlStyle = {
    width: '200px'
}
export const projectHeaderStyle = {
    textAlign: 'center'
}

export const desktopDropdownMenuContainer ={
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 20
}

export const  dividerStyle= {
    height: 2,
    width: "80%",
    marginLeft: "10%",
    marginRight: "10%",
    backgroundColor: "#30ACFF",
    marginTop: 20,
    marginBotton: 20
}


// WEBPACK FOOTER //
// ./src/components/projects/styles/desktop.js